import React from "react";

export default function Footer({ brand }) {
  const dark = brand?.key === "blackpekoe";
  const bg = dark ? "rgba(255,255,255,0.03)" : "#F5F2EB";
  const fg = dark ? "rgba(245,242,235,0.7)" : "#5C5753";
  const border = dark ? "rgba(255,255,255,0.06)" : "rgba(45,38,34,0.1)";
  const title = dark ? "#F5F2EB" : "#2D2622";
  const muted = dark ? "rgba(245,242,235,0.45)" : "#8C8581";
  const brandName = brand?.name || "Big Billion Food & Beverages";

  return (
    <footer className="mt-24" style={{ borderTop: `1px solid ${border}`, background: bg, color: fg }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10 grid md:grid-cols-3 gap-8 text-sm">
        <div>
          <h4 className="font-heading font-bold mb-2" style={{ color: title }}>{brandName}</h4>
          <p className="leading-relaxed">
            {brand?.tagline || "Wholesale supplier of tea, milk, sugar, and essentials."} — a brand of Big Billion Food and Beverages Pvt. Ltd.
          </p>
        </div>
        <div>
          <p className="overline mb-2" style={{ color: muted }}>Contact</p>
          <p>orders@bigbillion.com</p>
          <p>+91 80000 00000</p>
        </div>
        <div>
          <p className="overline mb-2" style={{ color: muted }}>Hours</p>
          <p>Mon — Sat &middot; 9 AM to 7 PM</p>
          <p>Delivery in 24–48 hours</p>
        </div>
      </div>
      <div className="py-4 text-center text-xs" style={{ color: muted, borderTop: `1px solid ${border}` }}>
        &copy; {new Date().getFullYear()} Big Billion Food and Beverages Private Limited
      </div>
    </footer>
  );
}
